import script from "./LegendDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegendDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./LegendDrawer.vue?vue&type=style&index=0&id=86972896&lang=css"

const __exports__ = script;

export default __exports__